import React from "react";
import CustomTable from "components/CustomTable";
import usePotentialCustomerList from "../usePotentialCustomerList";
import Toolbar from "../Toolbar";
import AddPotentialCustomer from "../../AddPotentialCustomer";
import PotentialCustomerDetailBlock from "features/PotentialCustomer/PotentialCustomerDetailBlock";

function CustomerCompletedTab({ isAgent }) {
  const {
    restTable,
    handleSearch,
    params,
    handleChangeParams,
    isShowDrawerDetail,
    handleCloseDrawerDetail,
    customerId,
  } = usePotentialCustomerList({ isAgent });

  return (
    <>
      <Toolbar
        onSearch={handleSearch}
        params={params}
        onChangeParams={handleChangeParams}
        customButton={<AddPotentialCustomer />}
        isAgent={isAgent}
      />
      <CustomTable {...restTable} />
      <PotentialCustomerDetailBlock
        visible={isShowDrawerDetail}
        onClose={handleCloseDrawerDetail}
        customerId={customerId}
        isAgent={isAgent}
      />
    </>
  );
}

export default CustomerCompletedTab;
